import { 音韻地位 } from 'tshet-uinh';

import { 母2idx, 母idx2右位 } from '../utils/常量';
import 韻鏡位置 from './韻鏡位置';

/**
 * 將切韻音系音韻地位轉換為韻鏡位置物件。
 */
const 音韻地位2韻鏡位置 = (當前音韻地位: 音韻地位) => {
  const { 母, 呼, 等, 類, 韻, 聲 } = 當前音韻地位;

  // calculate 韻鏡等
  const needAddOne = 類 === 'A' || ([...'精清從心邪以'].includes(母) && 等 === '三') || 韻 === '幽'; // 重紐四等、假四等真三等、幽韻為四等位
  const needMinusOne = [...'莊初崇生俟'].includes(母) && 等 === '三'; // 假二等真三等
  const 韻鏡等 = [...'一二三四'].indexOf(等) + 1 + (needAddOne ? 1 : needMinusOne ? -1 : 0);

  // calculate 轉號
  const 轉號 = _母類呼韻聲2轉號(母, 呼, 類, 韻, 聲, 韻鏡等);

  // calculate 上位
  const need寄入 = [...'廢夬'].includes(韻); // 標註「去聲寄此」
  const 上位 = (need寄入 ? 3 : [...'平上去入'].indexOf(聲)) * 4 + 韻鏡等;

  // calculate 右位
  const 右位 = 母idx2右位[母2idx.indexOf(母)]; // TODO: 常船位置

  return new 韻鏡位置(轉號, 上位, 右位);
};

const _母類呼韻聲2轉號 = (母: string, 呼: string | null, 類: string | null, 韻: string, 聲: string, 韻鏡等: number) => {
  if (呼 === null) {
    // TODO: cannot use 開口?
    const shouldUse合口 =
      [...'微廢夬元寒歌'].includes(韻) ||
      ([...'佳皆'].includes(韻) && 聲 === '去') ||
      (韻 === '刪' && 聲 !== '入') ||
      (韻 === '山' && 聲 === '入') ||
      (韻 === '仙' && 聲 === '去' && 類 === 'B');
    呼 = shouldUse合口 ? '合' : '開';
  }

  switch (韻) {
    case '東':
      return 1;
    case '冬':
    case '鍾':
      return 2;
    case '江':
      return 3;
    case '支':
      if (呼 === '開') {
        return 4;
      }
      return 5;
    case '脂':
      if (呼 === '開') {
        return 6;
      }
      return 7;
    case '之':
      return 8;
    case '微':
      if (呼 === '開') {
        return 9;
      }
      return 10;
    case '廢':
      if (呼 === '開') {
        return 9;
      }
      return 10;
    case '魚':
      return 11;
    case '虞':
    case '模':
      return 12;
    case '齊':
    case '夬':
    case '皆':
      if (呼 === '開') {
        return 13;
      }
      return 14;
    case '咍':
      return 13;
    case '灰':
      return 14;
    case '祭':
      if (韻鏡等 === 3) {
        if (呼 === '開') {
          return 13;
        }
        return 14;
      } else if (韻鏡等 === 4) {
        if (呼 === '開') {
          return 15;
        }
        return 16;
      }
      throw new Error(`韻鏡等 ${韻鏡等} invalid for 祭韻`);
    case '佳':
    case '泰':
      if (呼 === '開') {
        return 15;
      }
      return 16;
    case '痕':
    case '臻':
      return 17;
    case '魂':
      return 18;
    case '真':
      if (呼 === '開') {
        return 17;
      }
      return 18;
    case '殷':
      return 19;
    case '文':
      return 20;
    case '元':
      if (呼 === '開') {
        return 21;
      }
      return 22;
    case '山':
      if (聲 === '入') {
        if (呼 === '開') {
          return 23;
        }
        return 24;
      }
      if (呼 === '開') {
        return 21;
      }
      return 22;
    case '刪':
      if (聲 === '入') {
        if (呼 === '開') {
          return 21;
        }
        return 22;
      }
      if (呼 === '開') {
        return 23;
      }
      return 24;
    case '仙':
      if (韻鏡等 === 3) {
        if (呼 === '開') {
          return 23;
        }
        return 24;
      } else if (韻鏡等 === 2 || 韻鏡等 === 4) {
        if (呼 === '開') {
          return 21;
        }
        return 22;
      }
      throw new Error('error');
    case '寒':
    case '先':
      if (呼 === '開') {
        return 23;
      }
      return 24;
    case '蕭':
    case '肴':
    case '豪':
      return 25;
    case '宵':
      if (類 === 'A' || [...'精清從心邪以'].includes(母)) {
        return 26;
      }
      return 25;
    case '歌':
      if (呼 === '開') {
        return 27;
      }
      return 28;
    case '麻':
      if (呼 === '開') {
        return 29;
      }
      return 30;
    case '陽':
    case '唐':
      if (呼 === '開') {
        return 31;
      }
      return 32;
    case '庚':
      if (呼 === '開') {
        return 33;
      }
      return 34;
    case '清':
      if (韻鏡等 === 3) {
        if (呼 === '開') {
          return 35;
        }
        throw new Error('error: no 合口');
      } else if (韻鏡等 === 4) {
        if (呼 === '開') {
          return 33;
        }
        return 34;
      }
      throw new Error('error');
    case '耕':
    case '青':
      if (呼 === '開') {
        return 35;
      }
      return 36;
    case '尤':
    case '侯':
    case '幽':
      return 37;
    case '侵':
      return 38;
    case '鹽':
      if (韻鏡等 === 3) {
        return 39;
      } else if (韻鏡等 === 4) {
        return 40;
      }
      throw new Error(`韻鏡等 ${韻鏡等} invalid for 鹽韻`);
    case '覃':
    case '咸':
    case '添':
      return 39;
    case '談':
    case '銜':
      return 40;
    case '嚴':
      if (韻鏡等 === 3) {
        return 40;
      }
      throw new Error(`韻鏡等 ${韻鏡等} invalid for 嚴韻`);
    case '凡':
      return 41;
    case '登':
    case '蒸':
      if (呼 === '開') {
        return 42;
      }
      return 43;
    default:
      throw new Error('error');
  }
};

export default 音韻地位2韻鏡位置;
